<template>
  <section class="policy-documents__detail">
    <h5 class="mb-1 fs-7 text-gray-700 mb-2">Документы</h5>
    <template v-if="policy.product === 'OGPO_WEB_EA'">
      <div class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Полис PDF</h5>
            <div class="mb-2" v-if="!documentError">Автостраховка без поездки в офис или к агенту.</div>
            <div class="text-danger mb-2" v-else v-html="documentError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_policy"
                @click="getPolicyDocument"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedDocument ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedDocument"
            ></button>
            <button
                v-if="policy.document_policy"
                type="button"
                @click="openDocumentInNewTab(policy.document_policy, 'Полис')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_policy"
                type="button"
                @click="showPolicy = !showPolicy"
                v-html="showPolicy ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showPolicy && policy.document_policy"
            :data="'data:application/pdf;base64,'+policy.document_policy+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
      <div v-if="policy.product_type !== 'ОГПО ВТС (BPM)'" class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Заявление PDF</h5>
            <div class="mb-2" v-if="!contractError">Автостраховка без поездки в офис или к агенту.</div>
            <div class="text-danger mb-2" v-else v-html="contractError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_contract"
                @click="getPolicyContract"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedContract ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedContract"
            ></button>
            <button
                v-if="policy.document_contract"
                type="button"
                @click="openDocumentInNewTab(policy.document_contract, 'Заявление')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_contract"
                type="button"
                @click="showContract = !showContract"
                v-html="showContract ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showContract"
            :data="'data:application/pdf;base64,'+policy.document_contract+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
    </template>
    <template v-if="policy.product === 'DSI_FI' || policy.product === 'DSD_FI'">
      <div class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Договор PDF</h5>
            <div class="mb-2" v-if="!documentError">Автостраховка без поездки в офис или к агенту.</div>
            <div class="text-danger mb-2" v-else v-html="documentError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_policy"
                @click="getPolicyDocumentDC"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedDocument ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedDocument"
            ></button>
            <button
                v-if="policy.document_policy"
                type="button"
                @click="openDocumentInNewTab(policy.document_policy, 'Договор')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_policy"
                type="button"
                @click="showPolicy = !showPolicy"
                v-html="showPolicy ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showPolicy && policy.document_policy"
            :data="'data:application/pdf;base64,'+policy.document_policy+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
      <div class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Заявление PDF</h5>
            <div class="mb-2" v-if="!contractError">Автостраховка без поездки в офис или к агенту.</div>
            <div class="text-danger mb-2" v-else v-html="contractError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_contract"
                @click="getPolicyDocumentDC"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedContract ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedContract"
            ></button>
            <button
                v-if="policy.document_contract"
                type="button"
                @click="openDocumentInNewTab(policy.document_contract, 'Заявление')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_contract"
                type="button"
                @click="showContract = !showContract"
                v-html="showContract ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showContract"
            :data="'data:application/pdf;base64,'+policy.document_contract+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
    </template>
    <template v-if="policy.product === 'DSAT_CASCO_FRE' || policy.product === 'DSAT_CASCO_TRL' || policy.product === 'DSAT_CASCO_SE1' || policy.product === 'DSAT_CASCO_SE2'">
      <div class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Заявление PDF</h5>
            <div class="mb-2" v-if="!contractError">Автостраховка без поездки в офис или к агенту.</div>
            <div class="text-danger mb-2" v-else v-html="contractError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_contract"
                @click="getPolicyDocumentDS(0)"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedContract ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedContract"
            ></button>
            <button
                v-if="policy.document_contract"
                type="button"
                @click="openDocumentInNewTab(policy.document_contract, 'Заявление')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_contract"
                type="button"
                @click="showContract = !showContract"
                v-html="showContract ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showContract"
            :data="'data:application/pdf;base64,'+policy.document_contract+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
      <div class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Договор PDF</h5>
            <div class="mb-2" v-if="!documentError">Автостраховка без поездки в офис или к агенту.</div>
            <div class="text-danger mb-2" v-else v-html="documentError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_policy"
                @click="getPolicyDocumentDS(1)"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedDocument ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedDocument"
            ></button>
            <button
                v-if="policy.document_policy"
                type="button"
                @click="openDocumentInNewTab(policy.document_policy, 'Договор')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_policy"
                type="button"
                @click="showPolicy = !showPolicy"
                v-html="showPolicy ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showPolicy && policy.document_policy"
            :data="'data:application/pdf;base64,'+policy.document_policy+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
      <div class="border rounded p-5 mb-2">
        <div class="d-flex">
          <div class="mb-0">
            <h5 class="mb-1">Приложение PDF</h5>
            <div class="mb-2" v-if="!applicationError">Зафиксированная на материальном носителе информация в виде текста.</div>
            <div class="text-danger mb-2" v-else v-html="applicationError"></div>
          </div>
          <div class="ms-auto d-flex">
            <button
                v-if="!policy.document_application"
                @click="getPolicyDocumentDS(2)"
                type="button"
                class="btn btn-xs h-30px btn-primary"
                v-html="loadedApplication ? 'Поиск документа...' : 'Загрузить'"
                :disabled="loadedApplication"
            ></button>
            <button
                v-if="policy.document_application"
                type="button"
                @click="openDocumentInNewTab(policy.document_application, 'Приложение')"
                class="btn btn-xs h-30px btn-success me-2">
              Открыть
            </button>
            <button
                v-if="policy.document_application"
                type="button"
                @click="showApplication = !showApplication"
                v-html="showApplication ? 'Скрыть' : 'Показать'"
                class="btn btn-xs h-30px btn-light-primary">
            </button>
          </div>
        </div>
        <object
            v-if="showApplication && policy.document_application"
            :data="'data:application/pdf;base64,'+policy.document_application+'#view=Fit'"
            type="application/pdf"
            width="100%"
            style="height: 60vh"
        />
      </div>
    </template>
    <div class="border rounded p-5 mb-2" v-if="policy.wk_ticket">
      <div class="d-flex">
        <div class="mb-0">
          <h5 class="mb-1">Чек</h5>
          <div class="mb-2">Автостраховка без поездки в офис или к агенту.</div>
        </div>
        <a :href="policy.wk_ticket" target="_blank" type="button" class="btn btn-xs h-30px btn-light-primary ms-auto">
          Открыть
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: 'PolicyDocuments',
  props: {
    policy: null
  },
  data() {
    return {
      loadedApplication: false,
      applicationError:  null,
      loadedDocument:    false,
      documentError:     null,
      loadedContract:    false,
      contractError:     null,
      showApplication:   false,
      showContract:      false,
      showPolicy:        false
    }
  },
  methods: {
    openDocumentInNewTab(base64Data) {
      const clean = base64Data.replace(/^data:application\/pdf;base64,/, '');

      const binary = atob(clean);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) { bytes[i] = binary.charCodeAt(i) }
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    },
    getPolicyDocument() {
      this.documentError = null
      this.loadedDocument = true
      axios.post('/api/v2/contract/print/pdf', { global: this.policy.global_id })
          .then(res => {
            if (!res.data.result) {
              this.documentError = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
              this.$notifyError(res.data)
            } else {
              this.policy.document_policy = res.data.file
              this.documentError          = null
            }
          })
          .catch(err => {
            this.documentError = err.message
            this.$notifyError(err)
          })
          .finally(() => {
            this.loadedDocument = false
          })
    },
    getPolicyContract() {
      this.contractError = null
      this.loadedContract = true
      axios.post('/api/policy/get-document', {global: this.policy.global_id, type: 1})
          .then(res => {
            if (!res.data.result) {
              this.contractError = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
              this.$notifyError(res.data)
            } else {
              this.policy.document_contract = res.data.document
              this.contractError            = null
            }
          })
          .catch(err => {
            this.contractError = err.message
            this.$notifyError(err)
          })
          .finally(() => {
            this.loadedContract = false
          })
    },
    getPolicyDocumentDC() {
      this.contractError  = null
      this.documentError  = null
      this.loadedContract = true
      this.loadedDocument = true
      axios.post('/api/policy/get-document-dc', {global: this.policy.global_id, is_immovable: this.policy.product === 'DSI_FI' ? 1 : 0})
          .then(res => {
            if (!res.data.result) {
              this.contractError = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
              this.documentError = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
              this.$notifyError(res.data)
            } else {
              this.policy.document_contract = res.data[0].document_contract
              this.policy.document_policy   = res.data[0].document_policy
              this.contractError  = null
              this.documentError  = null
            }
          })
          .catch(err => {
            this.contractError = err.message
            this.documentError = err.message
            this.$notifyError(err)
          })
          .finally(() => {
            this.loadedContract = false
            this.loadedDocument = false
          })
    },
    getPolicyDocumentDS(type) {
      if (type === 0) {
        this.contractError  = null
        this.loadedContract = true
      } else if (type === 1) {
        this.documentError  = null
        this.loadedDocument = true
      } else {
        this.applicationError  = null
        this.loadedApplication = true
      }
      axios.post('/api/policy/get-document-ds', {global: this.policy.global_id, type:type})
          .then(res => {
            if (!res.data.result) {
              if (type === 0) {
                this.contractError    = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
                this.$notifyError(res.data)
              } else if (type === 1){
                this.documentError    = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
                this.$notifyError(res.data)
              } else {
                this.applicationError = res.data.message ?? (Array.isArray(res.data.errors) ? res.data.errors.join(', ') : '')
                this.$notifyError(res.data)
              }
            } else {
              if (type === 0) {
                this.policy.document_contract      = res.data[0].document_contract
                this.contractError                 = null
              } else if (type === 1) {
                this.policy.document_policy        = res.data[0].document_policy
                this.documentError                 = null
              } else {
                this.policy.document_application   = res.data[0].document_application
                this.applicationError              = null
              }
            }
          })
          .catch(err => {
            if (type === 0) {
              this.contractError    = err.message
            } else if (type === 1) {
              this.documentError    = err.message
            } else {
              this.applicationError = err.message
            }
            this.$notifyError(err)
          })
          .finally(() => {
            if (type === 0) {
              this.loadedContract     = false
            } else if (type === 1) {
              this.loadedDocument     = false
            } else {
              this.loadedApplication  = false
            }
          })
    }
  },
  watch: {
    policy: {
      deep: true,
      handler(newValue) {
        if (newValue.id) {
          this.loadedDocument = false
          this.documentError  = null
          this.loadedContract = false
          this.contractError  = null
          this.loadedApplication = false
          this.applicationError  = null
        }
      }
    }
  }
}
</script>

<style scoped>

</style>